import { GetServerSidePropsContext } from 'next';

import { Locale } from '@silvertours/back-domain-sitegroup';
import { LandingPageServerSideRequest } from '@silvertours/back-runtime-landingpages';
import { LandingPageLegacy } from '@silvertours/front-pages';

/**
 * Variant of the index page for the A/B test of the first viewport.
 * Akamai rewrites "/" to this path for group b. The path must end with
 * ".html", because the S3 page sync accepts only ".html" paths.
 */
export const getServerSideProps = (nextContext: GetServerSidePropsContext) => {
  const handler = new LandingPageServerSideRequest(Locale.German.value);

  return handler.getServerSideProps(nextContext);
};

export default LandingPageLegacy.HomeVariantLandingPage;
